import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  const {
    guarantee
  } = pageData;
  return <section className="py-20 px-4" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-900 border border-slate-800 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-77">
          <ShieldCheckIcon className="absolute -right-10 -bottom-10 w-64 h-64 text-white/[0.02] pointer-events-none" data-id="element-78" />

          <div className="relative z-10" data-id="element-79">
            <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-80">
              <ShieldCheckIcon className="w-8 h-8 text-green-500" data-id="element-81" />
            </div>

            <h2 className="text-3xl md:text-4xl mb-6" data-id="element-82">{guarantee.heading}</h2>

            <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-83">
              {guarantee.text}
            </p>

            <p className="text-gold-500 font-bold" data-id="element-84">{guarantee.subtext}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}